import script from "./bancaiDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./bancaiDetails.vue?vue&type=script&setup=true&lang=js"

import "./bancaiDetails.vue?vue&type=style&index=0&id=65a0db0e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a0db0e"]])

export default __exports__